const satV2Zone = '/sat-v2-zone';

export const routes = {
  base: satV2Zone,
  
  // Main Module Routes
  schoolStructure: `${satV2Zone}/school-structure`,
  curriculumManagement: `${satV2Zone}/curriculum-management`,
  peopleManagement: `${satV2Zone}/people-management`,
  timetableConfiguration: `${satV2Zone}/timetable-configuration`,
  scheduleGeneration: `${satV2Zone}/schedule-generation`,
  conflictResolution: `${satV2Zone}/conflict-resolution`,
  viewsDistribution: `${satV2Zone}/views-distribution`,
  rulesConstraints: `${satV2Zone}/rules-constraints`,
  
  // Utility Routes
  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-v2-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    // Remove the baseName portion
    relative = absolutePath.substring(baseName.length);
  }

  // If there's a leading '/', strip it out so the returned path doesn't start with '/'
  return relative.startsWith('/') ? relative.substring(1) : relative;
}
